import { TIPTAP_PDF_STYLE_ADJUSTMENTS } from './pdfStyleAdjustments';

export const adjustHighlightElements = (clonedDoc: Document) => {
  // 하이라이트 요소 위치 조정 (원래 위치에서 위로 올라가는 문제 해결)
  const clonedHighlight = clonedDoc.querySelectorAll('mark');
  clonedHighlight.forEach(highlight => {
    const element = highlight as HTMLElement;

    // mark 태그의 배경만 아래로 이동시키고 텍스트는 원래 자리에 유지
    element.style.position = 'relative';
    element.style.display = 'inline';
    element.style.verticalAlign = 'baseline';

    // 부모 요소에 밑줄이 있는지 확인
    const parentElement = element.parentElement;
    const hasUnderlineParent =
      parentElement &&
      (parentElement.tagName.toLowerCase() === 'u' ||
        (parentElement.style.textDecoration &&
          parentElement.style.textDecoration.includes('underline')));

    // 하이라이트 배경 위치 조정 (mark 태그 자체를 아래로 이동)
    const offsetY = TIPTAP_PDF_STYLE_ADJUSTMENTS.highlight.translateY;
    element.style.top = offsetY;

    // 부모에 밑줄이 있는 경우만 mark 태그에 밑줄 적용
    if (hasUnderlineParent) {
      element.style.textDecoration = 'underline';
      element.style.textDecorationThickness =
        TIPTAP_PDF_STYLE_ADJUSTMENTS.underline.textDecorationThickness;
    }

    // mark 태그의 직접적인 자식 노드들만 반대 방향으로 이동시켜서 원래 위치로 되돌림
    Array.from(element.childNodes).forEach(childNode => {
      // Element 노드인 경우에만 스타일 적용
      if (childNode.nodeType === Node.ELEMENT_NODE) {
        const childElement = childNode as HTMLElement;
        childElement.style.position = 'relative';
        // offsetY가 '10px'라면 반대는 '-10px'가 되도록 계산
        const reverseOffset = offsetY.startsWith('-')
          ? offsetY.substring(1)
          : `-${offsetY}`;
        childElement.style.top = reverseOffset; // 반대 방향으로 이동

        // 부모에 밑줄이 있는 경우 자식 요소에도 상속
        if (hasUnderlineParent) {
          childElement.style.textDecoration = 'underline';
          childElement.style.textDecorationThickness =
            TIPTAP_PDF_STYLE_ADJUSTMENTS.underline.textDecorationThickness;
        }
      }
      // 텍스트 노드인 경우 wrapping 처리
      else if (
        childNode.nodeType === Node.TEXT_NODE &&
        childNode.textContent?.trim()
      ) {
        const wrapper = clonedDoc.createElement('span');
        wrapper.style.position = 'relative';
        const reverseOffset = offsetY.startsWith('-')
          ? offsetY.substring(1)
          : `-${offsetY}`;
        wrapper.style.top = reverseOffset;

        // 부모에 밑줄이 있는 경우 wrapper에도 적용
        if (hasUnderlineParent) {
          wrapper.style.textDecoration = 'underline';
          wrapper.style.textDecorationThickness =
            TIPTAP_PDF_STYLE_ADJUSTMENTS.underline.textDecorationThickness;
        }

        // 텍스트 노드를 span으로 감싸기
        const parent = childNode.parentNode;
        if (parent) {
          parent.insertBefore(wrapper, childNode);
          wrapper.appendChild(childNode);
        }
      }
    });
  });
};
